var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8CheckDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35,24c-6.075,0-11,4.925-11,11s4.925,11,11,11s11-4.925,11-11S41.075,24,35,24z M41.707,31.707l-8,8 C33.512,39.902,33.256,40,33,40s-0.512-0.098-0.707-0.293l-4-4c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0L33,37.586 l7.293-7.293c0.391-0.391,1.023-0.391,1.414,0S42.098,31.316,41.707,31.707z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22,35h-4.509c-0.828,0-1.5-0.672-1.5-1.5c0-0.759,0.564-1.387,1.296-1.486L17.491,32h4.872 c0.344-1.446,0.925-2.785,1.708-4h-6.58c-0.828,0-1.5-0.685-1.5-1.514c0-0.759,0.564-1.387,1.296-1.486l0.204-0.014h9.229 C28.971,23.122,31.856,22,35,22c1.771,0,3.46,0.359,5,1.003V20H28.5c-2.481,0-4.5-2.019-4.5-4.5V4H12.5C10.019,4,8,6.019,8,8.5v31 c0,2.481,2.019,4.5,4.5,4.5h13.141C23.392,41.662,22,38.493,22,35z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5,17h10.621L27,4.879V15.5C27,16.327,27.673,17,28.5,17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CheckDocument);
export default __webpack_public_path__ + "static/media/icons8-check-document.8878b05730fe62c5c1c7cd4281fb3342.svg";
export { ForwardRef as ReactComponent };